export default "__VITE_ASSET__BOTcqtGI__"